import { fail } from "assert";
import { warn } from "console";

export const de = {
  common: {
    cancel: "Abbrechen",
    delete: "Löschen",
    generate: "Erstellen",
    invalid: "Ungültige Datei",
    loading: "Lade Inhalte...",
    preview: "Vorschau",
    reset: "Passwort ändern",
    save: "Speichern",
  },
  auth: {
    copyright: "© 2026 Spotlight Manager ist ein Produkt der Redlof Medien GmbH & Co. KG, Ansbach",
    email: "E-Mail",
    legal: "Impressum",
    login: "Anmelden",
    logout: "Abmelden",
    privacy: "Datenschutz",
    pwd: "Passwort",
    welcome: "Willkommen, {name}!",
  },
  dd:{
    All: "Alle",
    Approved: "Freigegeben",
    AwaitingApproval: "Warten auf Freigabe",
    Denied: "Abgelehnt",
    Editing: "Bearbeiten",
    Select: "Bitte wählen...",
  },
  playlist:{
    bookings: "Buchung/en",
    customer: "Kunde",
    duration: "Länge", 
    durationBooked: "Gebucht", 
    name: "Name",
    orderBegin: "Beginn",
    orderEnd: "Ende", 
    rotation: "Rotation", 
  },
  ui: {
    0:"A",
    1:"B",
    2:"C",
    active: "Aktiv",
    addLogo: "Datei für Logo hinzufügen",
    address: "Adresse",
    addSite: "Standort hinzufügen",
    admin: "Administrator",
    allMediaFilesNeedUpload: "Alle Formate müssen hochgeladen werden.",
    approve: "Freigeben",
    book: "Buchung hinzufügen",
    bookedlength: "Gebuchte Länge",
    bookingInfo: "Buchungsdetails",
    bookinginfo: "Buchungsinfo",
    bookings: "Buchungen",
    changeDate: "Änderungsdatum",
    actions: "Aktionen",
    dashboard: "Dashboard",
    cell: "Mobil",
    choose: "Bitte wählen:",
    city: "Stadt",
    company: "Firma",
    companyinfo: "Firmendetails",
    companysearch: "Nach Firma suchen...",
    confirmdeletebooking: "Möchten Sie diese Buchung löschen?",
    container: "Container",
    copybooking: "Spot auch für diese Standorte buchen:",
    customer: "Firma",
    customers: "Firmen",
    deletebooking: "Buchung löschen",
    deny: "Ablehnen",
    duration: "Dauer",
    editor: "Template Editor",
    email: "E-Mail",
    enddate: "Ende",
    error: "Fehler",
    excludeorders: "Vergangene Aufträge ausblenden",//Exclude Past Orders
    failedsave: "Fehler: ",
    fax: "Fax",
    fileTooLarge: "Die Dateigröße überschreitet das Limit von 20MB.",
    fileWarning: "Warnung: Die Dateigröße sollte nicht über 10MB liegen.",
    firstname: "Vorname",
    foldername: "Ordnername für Uploads",
    format: "Format",
    lastname: "Nachname",
    line: "Linie",
    loop: "Schleife",
    looplength: "Schleifen Länge",
    media: "Logo",
    mediaNotAvailableYet: "Medien werden convertiert. Dieser Vorgang kann einige Minuten dauern. Bitte versuchen Sie es später erneut.",
    menu: "Menü",
    name: "Name",
    neededForOrders: "Format wird für diese Aufträge benötigt",
    nomediaforaspectratio: "Diese Format wird nicht unterstützt.",
    note: "Notizen",
    noTemplates:"Es gibt noch keine Templates.",
    occupancy: "Auslastung",
    order: "Auftrag",
    orderinfo: "Auftragsdetails",
    orderlength: "Aufträge Länge",
    orderLength: "Dauer",
    orders: "Aufträge",
    page: "Seite",
    phone: "Telefon",
    playlist: "Playlist",
    playlists: "Playlists",
    pleaseNote: "Bitte beachten:",
    role: "Rolle",
    rotation: "Rotation",
    searchorder: "Nach Auftrag suchen...",//Search for order...
    searchspot: "Nach Spot suchen...",//Search for spot...
    select: "",
    selectFile: "Datei wählen",
    selectTemplate: "Template auswählen",
    site: "Standort",
    spot: "Spot",
    spotinfo: "Spotdetails",
    spotpersiteerror: "Der Spot konnte für die folgenden Standorte nicht gebucht werden:",
    spots: "Spots",
    startdate: "Beginn",
    status_1: "Bearbeiten",
    status_2: "Warten auf Freigabe",
    status_3: "Freigegeben",
    status_4: "Abgelehnt",
    status_active: "Aktiv",
    status: "Status",
    street: "Straße",
    submitForApproval: "Zur Genehmigung einreichen",
    templates: "Templates",
    type: "Typ",
    undoApproval: "Spot ändern",
    undoApprovalText: "Achtung: Dadurch wird der Spot änderbar und muss erneut genehmigt werden. In dieser Zeit wird der Spot nicht mehr abgespielt. Möchten Sie fortfahren?",
    uploadFile: "Datei hochladen",
    username: "Name",
    usernameInfo: "Benutzername",
    users: "Benutzer",
    usersActiveOnly: "nur aktive Benutzer",
    userAutoApprove: "Spots automatisch genehmigen",
    userInfo: "Benutzerinformationen",
    userPwd: "Passwort",
    userSearch: "Nach Benutzer suchen...",
    viewspot: "Spot öffnen",
    warning: "Achtung",
    website: "Webseite",
    zip: "PLZ",
    createspot: "Spot erstellen",
    monitor: "Monitor Dienste",
    width: "Breite",
    height: "Höhe",
    notPossible: "Es liegen keine aktiven Aufträge vor. Es können keine Spots erstellt werden.",
    selectCustomer: "Bitte wählen Sie einen Kunden aus der Liste aus."
  
  }
} as const;